import { ConstantItems, getDefaultConfig, Constants } from "../../constants";
import * as _ from "lodash";

export class ClientRepo {
  static $inject = ["$http", "config"];

  constructor(
    private $http: angular.IHttpService,
    private config: ConstantItems
  ) {}

  getClient(clientNumber: string, isActive?: boolean) {
    let config = getDefaultConfig();
    config.params = {
      isActive: isActive,
    };
    return this.$http.get(`${this.config.clientUrl}/${clientNumber}`, config);
  }

  getClientReportingName(clientNumber: string) {
    return this.$http.get(
      `${this.config.clientUrl}/${clientNumber}/reportingName`
    );
  }

  getClients(
    page: string,
    itemsPerPage: string,
    searchText: string,
    searchColumn: string,
    orderColumn: string,
    orderDirection: string,
    displayAllClients: boolean,
    selectedInvestmentOfficers: Array<string>,
    selectedPortfolioManagers: Array<string>,
    displayActive: boolean = false
  ) {
    let queryParams = {
      page: page,
      itemsPerPage: itemsPerPage,
      searchText: searchText,
      searchColumn: searchColumn,
      orderColumn: orderColumn,
      orderDirection: orderDirection,
      displayAllClients: displayAllClients.toString(),
      selectedInvestmentOfficers: selectedInvestmentOfficers,
      selectedPortfolioManagers: selectedPortfolioManagers,
      displayActiveClients: displayActive,
    };

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(`${this.config.clientUrl}`, config);
  }

  getUserClients() {
    return this.$http.get(`${this.config.clientUrl}/UserClients`);
  }

  getClientsForUser(userId: number) {
    return this.$http.get(`${this.config.clientUrl}/users/${userId}`);
  }

  saveClient(client) {
    return this.$http.put(this.config.clientUrl, client);
  }

  refreshClients(
    page: string,
    itemsPerPage: string,
    searchText: string,
    searchColumn: string,
    orderColumn: string,
    orderDirection: string,
    displayAllClients: boolean,
    selectedInvestmentOfficers: Array<string>,
    selectedPortfolioManagers: Array<string>,
    displayActive: boolean = false
  ) {
    let queryParams = {
      page: page,
      itemsPerPage: itemsPerPage,
      searchText: searchText,
      searchColumn: searchColumn,
      orderColumn: orderColumn,
      orderDirection: orderDirection,
      displayAllClients: displayAllClients.toString(),
      selectedInvestmentOfficers: selectedInvestmentOfficers,
      selectedPortfolioManagers: selectedPortfolioManagers,
      displayActiveClients: displayActive,
    };

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(`${this.config.clientRefreshUrl}`, config);
  }

  filterAccounts(searchText: string, clientId?: number) {
    var params = "searchText=" + searchText;
    if (clientId) {
      params += "&clientNumber=" + clientId;
    }
    return this.$http.get(`${this.config.accountsUrl}/${clientId}?${params}`);
  }

  // Generate the argument string for the request:
  private generateArguments(...args: Array<string>) {
    var parameterString = "";

    _.forEach(args, (arg) => {
      if (!_.isNull(arg) && !_.isEmpty(arg)) {
        if (_.isEmpty(parameterString)) parameterString = "?";
        else parameterString += "&";

        parameterString += arg;
      }
    });
    return parameterString;
  }

  getLatestPVDates() {
    return this.$http.get(`${this.config.clientUrl}/latestDataFeeds`);
  }

  getLatestGenericPVDates(latestDate) {
    var bucket = Constants.getBucket("generic");
    return this.$http.get(
      `${this.config.clientUrl}/latestGenericDataFeeds/${bucket}/${latestDate}`
    );
  }

  getClientFees(clientId: number) {
    let queryParams = {
      clientId: clientId,
    };

    let config = getDefaultConfig();
    config.params = queryParams;
    return this.$http.get(`${this.config.feesUrl}/clients`, config);
  }

  editPortfolioFees = (portfolioIds: Array<number>, portfolioFee: any) => {
    let queryParams = {
      portfolioIds: portfolioIds,
    };

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.put(
      `${this.config.feesUrl}/portfolios`,
      portfolioFee,
      config
    );
  };

  addPortfolioFees = (portfolioIds: Array<number>, portfolioFee: any) => {
    let queryParams = {
      portfolioIds: portfolioIds,
    };

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.post(
      `${this.config.feesUrl}/portfolios`,
      portfolioFee,
      config
    );
  };

  modifyDietz = (clientId: number, dietz: number) => {
    let data = {
      clientId,
      dietz
    };

    let config = getDefaultConfig();
    config.params = {}

    return this.$http.post(
      `${this.config.clientUrl}/modify-dietz`,
      data,
      config
    );
  };

  getFeeTypes = () => {
    return this.$http.get(`${this.config.feesUrl}/feetypes`);
  };

  transferPortfolio = (oldClientNumber, newClientNumber, portfolioName) => {
    return this.$http.put(
      `${this.config.clientUrl}/transferportfolio/${oldClientNumber}/${newClientNumber}/${portfolioName}`,
      {}
    );
  };
}



// WEBPACK FOOTER //
// ./src/app/clients/client.repo.ts